const AppDefaultValuesEnum = {
  LANGUAGE_ID: 1,
  LANGUAGE: 'en',
  PARTNER_ID: 4,
  GAME_ID: 141419,
  CURRENCY: 'USD',
  MODE: 'fun',
  APPLICATION_ID: 18,
};

Object.freeze(AppDefaultValuesEnum);

export { AppDefaultValuesEnum };
